import React from 'react'
import Image from 'next/image'
import { styled } from "@mui/material/styles";
import { Box, Typography } from '@mui/material';
import Link from "next/link";
import { Config, ImgUrl } from "@/config";
import Grid from '@mui/material/Unstable_Grid2';

const StyledBox = styled(Box)(({ theme }) => ({
	boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
	zIndex: 999,
	position: "fixed",
	width: "100%",
	background: "#FFF",
	maxWidth: "2500px",
	// padding: "0 15px",
	display: "inline-block"
}));
export default function urlAccountSignin({ getDataCampaign }: any) {

	return (
		<StyledBox>
			<Grid container alignItems="center">
				<Grid xs={6} sx={{ px: { xs: 2, sm: 4 } }}>
					<Link href="/">
						<Image
							src={
								getDataCampaign?.logo
									? `${ImgUrl.imageCampaign}/uploads/campaign/${getDataCampaign?.id}/logo/${getDataCampaign?.logo}`
									: `${ImgUrl.pathImg}web/logo.webp`
							}
							className="author-img rounded-circle"
							alt="maaboom"
							width={200}
							height={30}
							layout="fixed"
							// objectFit="contain"
							//   priority
							style={{
								width: "150px",
								height: "auto",
								marginTop: "15px",
								marginBottom: "5px",
								// marginLeft: "25px",
								// alignItems: "center",
								objectFit: 'contain',
							}}
							loading="lazy"
							placeholder="empty"
							blurDataURL={
								getDataCampaign?.logo
									? `${ImgUrl.imageCampaign}/uploads/campaign/${getDataCampaign?.id}/logo/${getDataCampaign?.logo}`
									: `${ImgUrl.pathImg}web/logo.webp`
							}
						/>
					</Link>
				</Grid>
				<Grid xs={6} sx={{ textAlign: "right", px: { xs: 2, sm: 4 } }}>
					<Link
						href={Config.apiSellerEndpoint}
						className="inline-block btn-to-seller"
						target='_blank'
					>
						<Typography variant="body2" sx={{ px: 1, fontSize: "14px", textAlign: "center" }}>
							เปิดร้านค้ากับ maaboom
						</Typography>
					</Link>
				</Grid>
			</Grid>
		</StyledBox>
	)
}